var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"display":"inline-flex"}},[_c('span',{staticClass:"item-name-loading"},[_vm._v("\n    "+_vm._s(_vm.C_calculatedNameLabel)+"\n    "),(_vm.showLoading === true)?_c('clip-loader',{attrs:{"loading":_vm.DV_isLoading,"color":'black',"size":'15px'}}):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d72f7d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Labels/c13ObjectAttributeNameLabel.vue
// module id = null
// module chunks = 